import { DateTime } from '@engage/internationalize';

var formatWithLocale = function formatWithLocale(formatter) {
  return function (time, getLocale) {
    return DateTime[formatter](time, getLocale);
  };
}; // Wrapped formatters


export var toLocalizedAbbreviatedLong = formatWithLocale('toLocalizedAbbreviatedLong');
export var toLocalizedAbrevLongWithoutDay = formatWithLocale('toLocalizedAbrevLongWithoutDay');
export var toLocalizedSlashedDate = formatWithLocale('toLocalizedSlashedDate');
export var toLocalizedDayNameMonthDate = formatWithLocale('toLocalizedDayNameMonthDate');
export var toLocalizedDayNameShortMonthDate = formatWithLocale('toLocalizedDayNameShortMonthDate');
export var toLocalizedDayNameShort = formatWithLocale('toLocalizedDayNameShort');
export var toLocalizedShortMonthDate = formatWithLocale('toLocalizedShortMonthDate');
export var toLocalizedDayFirstLetter = formatWithLocale('toLocalizedDayFirstLetter');
export var toLocalizedDayOfMonth = formatWithLocale('toLocalizedDayOfMonth');
export var toLocalizedMonthYear = formatWithLocale('toLocalizedMonthYear');
export var toLocalizedTime = formatWithLocale('toLocalizedTime');
export var toMonthNameShort = formatWithLocale('toMonthNameShort');